<template>
    <article>
        <p>
            The following inspections are based on the
            <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'node-agent', item: 'metrics'}, hash: '#jvm'}">JVM metrics</router-link> automatically collected by coroot-node-agent for each JVM running on the node.
            So, you don't need to configure anything!
        </p>

        <ul>
            <li>
                JVM availability: checks that every JVM is up and running
            </li>
            <li>
                JVM safepoints: detects situations when a java application has been stopped for a significant
                amount of time due to safepoint operations
            </li>
        </ul>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/jvm.png" />
        </v-card>
        
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
